/*
 * LBL behangcalculator (vervangt de MPC-app "Ex Custom Price Calculator").
 *
 * Eén cart-regel per bestelling: dezelfde variant, quantity = aantal eenheden (0,1 m2 per eenheid),
 * de maat staat als regel-eigenschappen (properties) op de cart-regel. Er worden GEEN producten of
 * varianten aangemaakt. Het formulier wordt gewoon door <product-form> van het thema verstuurd, zodat
 * winkelwagen-drawer, ververs-events en foutafhandeling van het thema ongewijzigd blijven werken.
 *
 * Zuivere rekenfuncties staan bovenaan en zijn los te testen (node: require() -> module.exports).
 */
(function (root) {
  'use strict';

  /* ---------- Zuivere functies ---------- */

  // "3,2" / "3.2" / " 320 " -> getal; leeg of onzin -> NaN
  function parseNumber(raw) {
    if (raw == null) return NaN;
    var s = String(raw).trim().replace(/\s+/g, '').replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(s)) return NaN;
    return parseFloat(s);
  }

  function toCm(value, unit) {
    return unit === 'm' ? value * 100 : value;
  }

  /*
   * Berekent aantal eenheden.
   *  lengthCm, widthCm : maten in cm
   *  unitM2            : m2 per eenheid (0.1 = per 0,1 m2; 1 = hele m2 als terugval)
   *  minM2             : minimale afname in m2
   * Afronden: omhoog naar hele eenheden (met 1e-9 marge tegen float-ruis).
   */
  function compute(lengthCm, widthCm, unitM2, minM2) {
    var areaM2 = (lengthCm * widthCm) / 10000;
    var unitCm2 = unitM2 * 10000;
    var rawUnits = (lengthCm * widthCm) / unitCm2;
    var units = Math.ceil(rawUnits - 1e-9);
    var minUnits = Math.ceil(minM2 / unitM2 - 1e-9);
    var minApplied = units < minUnits;
    var billedUnits = Math.max(units, minUnits);
    return {
      areaM2: areaM2,
      roundedM2: round(units * unitM2, 4),
      billedUnits: billedUnits,
      billedM2: round(billedUnits * unitM2, 4),
      minApplied: minApplied
    };
  }

  function round(n, d) {
    var f = Math.pow(10, d);
    return Math.round(n * f) / f;
  }

  // Valideert één maat in cm. Geeft foutcode of null.
  function validateDimension(cm, limits) {
    if (isNaN(cm)) return 'invalid';
    if (cm < limits.minCm) return 'too_small';
    if (cm > limits.maxCm) return 'too_large';
    return null;
  }

  var api = {
    parseNumber: parseNumber,
    toCm: toCm,
    compute: compute,
    validateDimension: validateDimension
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.LblBehangCalc = api;

  /* ---------- Gedrag in de browser ---------- */

  if (typeof document === 'undefined' || typeof HTMLElement === 'undefined') return;

  var nf = {};
  function number(n, digits, locale) {
    var key = locale + digits;
    if (!nf[key]) nf[key] = new Intl.NumberFormat(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits });
    return nf[key].format(n);
  }

  var TEXT = {
    nl: {
      empty: 'Vul de lengte en breedte van je muur in om de prijs te zien.',
      invalid: 'Vul een getal in, bijvoorbeeld 270.',
      too_small: 'Dit is erg klein. Controleer je maat of neem contact met ons op.',
      too_large: 'Dit is groter dan we online kunnen berekenen. Neem contact met ons op voor een maatwerkofferte.',
      area_too_large: 'Dit oppervlak is groter dan we online kunnen berekenen. Neem contact met ons op voor een maatwerkofferte.',
      measured: 'Je muur is',
      billing: 'Je betaalt voor',
      rounded_up: 'afgerond op',
      min_notice: 'Wij leveren minimaal {min} m². Je betaalt daarom voor {min} m².',
      whole_note: 'We rekenen per hele m², naar boven afgerond.',
      total: 'Totaal',
      per_m2: 'per m²',
      add: 'In winkelwagen',
      add_disabled: 'Vul eerst de maten in',
      adding: 'Toevoegen...'
    }
  };

  class LblBehangCalc extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.locale = (document.documentElement.lang || 'nl').slice(0, 2) === 'nl' ? 'nl-NL' : (document.documentElement.lang || 'nl-NL');
      this.t = TEXT.nl;
      this.unitM2 = parseFloat(this.dataset.unitM2) || 1;
      this.minM2 = parseFloat(this.dataset.minM2) || 4;
      this.unitPrice = parseInt(this.dataset.unitPriceCents, 10) || 0; // centen per eenheid
      this.currency = this.dataset.currency || 'EUR';
      this.limits = { minCm: 10, maxCm: 1500 };
      this.maxAreaM2 = 100;
      this.money = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency });

      this.$ = function (sel) { return this.querySelector(sel); };
      this.form = this.$('form');
      this.fLength = this.$('[data-calc-length]');
      this.fWidth = this.$('[data-calc-width]');
      this.fUnit = this.querySelectorAll('[name="calc_unit"]');
      this.out = this.$('[data-calc-result]');
      this.msgLength = this.$('[data-calc-err-length]');
      this.msgWidth = this.$('[data-calc-err-width]');
      this.submit = this.$('[data-calc-submit]');
      this.hint = this.$('[data-calc-hint]');
      this.qty = this.$('[data-calc-qty]');
      this.pTotal = this.$('[data-calc-prop-total]');
      this.pLength = this.$('[data-calc-prop-length]');
      this.pWidth = this.$('[data-calc-prop-width]');
      this.pLine = this.$('[data-calc-prop-line]');

      var self = this;
      [this.fLength, this.fWidth].forEach(function (el) {
        el.addEventListener('input', function () { self.touched = true; self.update(); });
        el.addEventListener('blur', function () { self.touched = true; self.update(); });
      });
      this.fUnit.forEach(function (el) { el.addEventListener('change', function () { self.update(); }); });

      // Beschermt tegen verzenden met ongeldige maat (capture, vóór <product-form>)
      this.form.addEventListener('submit', function (e) {
        if (!self.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.touched = true;
          self.update();
          (self.firstInvalid || self.fLength).focus();
          return;
        }
        // uniek per toevoeging: voorkomt dat twee gelijke maten in één regel samenvloeien (quantity zou dan verdubbelen)
        self.pLine.value = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      }, true);

      // Voorinvullen via ?lengte=270&breedte=320 (cm), o.a. voor "maat aanpassen" vanuit de winkelwagen
      try {
        var q = new URLSearchParams(window.location.search);
        if (q.get('lengte')) this.fLength.value = q.get('lengte');
        if (q.get('breedte')) this.fWidth.value = q.get('breedte');
        if (q.get('lengte') || q.get('breedte')) this.touched = true;
      } catch (e) { /* geen URLSearchParams: negeren */ }

      this.update();
    }

    unit() {
      var r = Array.prototype.find.call(this.fUnit, function (x) { return x.checked; });
      return r ? r.value : 'cm';
    }

    fieldState(input, errEl) {
      var raw = input.value;
      if (raw.trim() === '') return { cm: NaN, empty: true, err: null };
      var n = parseNumber(raw);
      var cm = toCm(n, this.unit());
      var code = validateDimension(cm, this.limits);
      return { cm: cm, empty: false, err: code };
    }

    setError(input, errEl, code) {
      var show = this.touched && code;
      input.setAttribute('aria-invalid', show ? 'true' : 'false');
      errEl.textContent = show ? this.t[code] : '';
      errEl.hidden = !show;
    }

    update() {
      var t = this.t;
      var L = this.fieldState(this.fLength);
      var B = this.fieldState(this.fWidth);
      this.setError(this.fLength, this.msgLength, L.err);
      this.setError(this.fWidth, this.msgWidth, B.err);
      this.firstInvalid = (L.err || L.empty) ? this.fLength : ((B.err || B.empty) ? this.fWidth : null);

      var ok = !L.empty && !B.empty && !L.err && !B.err;
      var areaTooLarge = ok && (L.cm * B.cm) / 10000 > this.maxAreaM2;
      var html = '';
      this.valid = false;

      if (!ok) {
        html = '<p class="lbl-calc__hintline">' + t.empty + '</p>';
        this.pTotal.value = ''; this.pLength.value = ''; this.pWidth.value = ''; this.qty.value = 1;
      } else if (areaTooLarge) {
        html = '<p class="lbl-calc__error">' + t.area_too_large + '</p>';
        this.pTotal.value = ''; this.qty.value = 1;
      } else {
        var r = compute(L.cm, B.cm, this.unitM2, this.minM2);
        var dec = this.unitM2 < 1 ? 1 : 0;
        var billed = number(r.billedM2, dec, this.locale);
        var lineTotal = r.billedUnits * this.unitPrice;
        var perM2 = this.unitPrice / this.unitM2;

        this.valid = true;
        this.qty.value = r.billedUnits;
        this.pLength.value = number(L.cm, L.cm % 1 ? 1 : 0, this.locale) + ' cm';
        this.pWidth.value = number(B.cm, B.cm % 1 ? 1 : 0, this.locale) + ' cm';
        this.pTotal.value = billed + ' m²';

        html += '<dl class="lbl-calc__rows">';
        html += '<div><dt>' + t.measured + '</dt><dd>' + number(L.cm / 100, 2, this.locale) + ' × ' + number(B.cm / 100, 2, this.locale) + ' m = ' + number(r.areaM2, 2, this.locale) + ' m²</dd></div>';
        html += '<div><dt>' + t.billing + '</dt><dd>' + billed + ' m² <span class="lbl-calc__muted">× ' + this.money.format(perM2 / 100) + '</span></dd></div>';
        html += '<div class="lbl-calc__total"><dt>' + t.total + '</dt><dd>' + this.money.format(lineTotal / 100) + '</dd></div>';
        html += '</dl>';
        if (r.minApplied) {
          html += '<p class="lbl-calc__notice">' + t.min_notice.replace(/\{min\}/g, number(this.minM2, 0, this.locale)) + '</p>';
        } else if (this.unitM2 >= 1) {
          html += '<p class="lbl-calc__muted">' + t.whole_note + '</p>';
        }
      }

      this.out.innerHTML = html;
      this.submit.disabled = !this.valid;
      this.submit.setAttribute('aria-disabled', this.valid ? 'false' : 'true');
      if (this.hint) this.hint.hidden = this.valid;
    }
  }

  if (!customElements.get('lbl-behang-calc')) customElements.define('lbl-behang-calc', LblBehangCalc);
})(typeof window !== 'undefined' ? window : globalThis);
